module.exports = __webpack_public_path__ + "static/media/sort-icon.54f7d9fc.svg";